import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from '../stores/auth';

export function Landing() {
  const navigate = useNavigate();
  const ready = useAuthStore((s) => s.ready);
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    if (ready && user) navigate('/app/home', { replace: true });
  }, [ready, user, navigate]);

  return (
    <div className="min-h-screen bg-base text-text-primary">
      <header className="mx-auto flex max-w-screen-md items-center justify-between px-6 py-5">
        <div className="flex items-center gap-2">
          <div className="h-7 w-7 rounded-lg bg-sage flex items-center justify-center text-sm font-bold text-white">N</div>
          <span className="text-base font-medium">Nudge</span>
        </div>
        <Link to="/welcome" className="rounded-lg bg-sage px-4 py-2 text-sm font-medium text-white">Open app</Link>
      </header>

      <main className="mx-auto max-w-screen-md px-6 py-10">
        <h1 className="text-3xl font-medium leading-tight md:text-4xl">
          Send a card. Skip the words.
        </h1>
        <p className="mt-4 max-w-xl text-base text-text-muted">
          Nudge is a private space for couples and small circles to share needs, energy, and moods through pre-agreed cards. Built for neurodivergent people who feel things deeply and don't always have language ready.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/welcome" className="rounded-xl bg-sage px-5 py-3 text-sm font-medium text-white">Get started</Link>
          <a
            href="https://buymeacoffee.com/nudgeapp"
            target="_blank"
            rel="noreferrer"
            className="rounded-xl border border-border-subtle bg-card px-5 py-3 text-sm text-text-primary"
          >
            ☕ Buy me a coffee
          </a>
        </div>

        <div className="mt-12 grid gap-4 md:grid-cols-3">
          {[
            { e: '🃏', t: 'Pre-agreed cards', b: 'A shared deck — no typing in hard moments.' },
            { e: '🌿', t: 'Soft or firm', b: 'Match how urgent it feels. Re-nudges when needed.' },
            { e: '🔒', t: 'Private', b: 'Just you and the people you invite. End-to-end visibility.' },
          ].map((f) => (
            <div key={f.t} className="rounded-2xl border border-border-subtle bg-card p-5">
              <div className="text-2xl" aria-hidden>{f.e}</div>
              <div className="mt-2 text-base font-medium">{f.t}</div>
              <div className="mt-1 text-sm text-text-muted">{f.b}</div>
            </div>
          ))}
        </div>
      </main>

      <footer className="mx-auto max-w-screen-md px-6 py-10 text-xs text-text-muted">
        <div className="flex flex-wrap gap-4">
          <Link to="/privacy" className="underline">Privacy</Link>
          <Link to="/terms" className="underline">Terms</Link>
          <Link to="/support" className="underline">Support</Link>
        </div>
      </footer>
    </div>
  );
}
